import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FundingSourceRequest} from "@app/shared/ach/ach-select-funding-source/funding-source-request";
import {AchDataService} from "@app/shared/ach/ach-data.service";
import {AchDefaultPaymentType, CommonTransformationService, Format, FundingSourceStatus, FundingSourceType, OrgAchDetail, PaymentTxnType, PaymentType, Validation} from "@app/shared";
import {AchFundingSource} from "@app/shared/ach/org-payment-transaction";
import {classToClass, plainToClass} from "class-transformer";
import {SelectItem} from "primeng/api";
import {SolutionManagerDataService} from "@app/solution-manager/solution-manager-data.service";

@Component({
  selector: 'app-ach-select-funding-source',
  templateUrl: './ach-select-funding-source.component.html',
  styleUrls: ['./ach-select-funding-source.component.css'],
  providers: [SolutionManagerDataService]
})
export class AchSelectFundingSourceComponent implements OnInit, OnChanges {

  achFundingSourceList: AchFundingSource[] | OrgAchDetail[] = [];
  selectedFundingSource: AchFundingSource | OrgAchDetail;
  achFundingDropDown: SelectItem[] = [];
  Validation: typeof Validation = Validation;
  Format: typeof Format = Format;
  @Output() selectedFundingSourceEvent = new EventEmitter<AchFundingSource | OrgAchDetail>();
  @Input() request: FundingSourceRequest;

  constructor(private dataService: AchDataService, private commonTransService: CommonTransformationService, private solutionManagerDataService: SolutionManagerDataService) {
  }


  ngOnInit() {
    this.getFundingSource(this.request);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getFundingSource(this.request);
  }

  onChangeFundingSource(fundingSource: AchFundingSource): void {
    this.selectedFundingSourceEvent.emit(fundingSource);
  }

  private getFundingSource(request: FundingSourceRequest): void {

    if (request) {
      if (request.paymentType == PaymentType.ACH) {
        //Use Ach service to get
        this.dataService.getFundingSourceForResource(request.refId, request.fundingSourceType, FundingSourceStatus.Verified).subscribe(res => {
          this.achFundingSourceList = plainToClass(AchFundingSource, res.list);
          this.setDefaultFundingSource(this.achFundingSourceList);
          this.achFundingDropDown = this.commonTransService.convertToDropDown("fundingSourceName", this.achFundingSourceList);
        });
      } else if (request.paymentType == PaymentType.Check && request.fundingSourceType == FundingSourceType.Org) {
        this.solutionManagerDataService.getOrgAchDetail(request.refId).subscribe(res => {
          const rxAchDetails = plainToClass(OrgAchDetail, res.list);
          this.achFundingSourceList = rxAchDetails.filter(ach => ach.enableCheckPayment);
          this.setDefaultFundingSource(this.achFundingSourceList);
          this.achFundingDropDown = this.commonTransService.convertToDropDown("nickName", this.achFundingSourceList);
        });
      }
    } else {
      console.warn("Couldn't get the funding source request");
    }
  }

  private setDefaultFundingSource(fundingSources: AchFundingSource[] | OrgAchDetail[]): void {
    //If it is org, Select Either Vendor_payable account or All account for vendor transactions
    if (this.request.fundingSourceType == FundingSourceType.Org) {
      this.setFundingSourceForOrg(fundingSources, this.request.paymentTxnType);
    } else if (this.request.fundingSourceType == FundingSourceType.Vendor) {
      this.setFundingSourceForVendor(fundingSources);
    } else if (this.request.fundingSourceType == FundingSourceType.Payee) {
      this.setFundingSourceForPayee(fundingSources);
    }
  }

  private setFundingSourceForOrg(fundingSources: AchFundingSource[] | OrgAchDetail[], paymentTxnType?: PaymentTxnType): void {
    //Search For VendorPayable Account
    if (this.request.paymentType == PaymentType.ACH) {
      this.setAchPaymentMethodForOrg(fundingSources, paymentTxnType);
    } else if (this.request.paymentType == PaymentType.Check) {
      this.setCheckPaymentMethodForOrg(fundingSources, paymentTxnType);
    }

  }

  private setFundingSourceForVendor(fundingSources: AchFundingSource[]): void {
    const activeVendorAccounts = fundingSources.filter(ach => ach.vendorActivePayAccount);
    if (activeVendorAccounts && activeVendorAccounts.length > 0) {
      this.selectedFundingSource = classToClass(activeVendorAccounts[0]);
    } else {
      this.selectedFundingSource = null;
    }
    this.selectedFundingSourceEvent.emit(this.selectedFundingSource);
  }

  private setFundingSourceForPayee(fundingSources: AchFundingSource[]): void {
    //Set the default funding source passed from the request
    if (this.request.defaultFundingSourceId) {
      const eligibleAccounts = fundingSources.filter(ach => ach.id == this.request.defaultFundingSourceId);
      if (eligibleAccounts && eligibleAccounts.length > 0) {
        this.selectedFundingSource = classToClass(eligibleAccounts[0]);
      } else {
        this.selectedFundingSource = null;
      }
      this.selectedFundingSourceEvent.emit(this.selectedFundingSource);
    }
  }

  private setAchPaymentMethodForOrg(fundingSources: AchFundingSource[], paymentTxnType?: PaymentTxnType): void {
    const vendorFundingSources = fundingSources.filter(achMethod => achMethod.achDefaultPaymentType == AchDefaultPaymentType.VendorPayable);
    const allFundingSources = fundingSources.filter(achMethod => achMethod.achDefaultPaymentType == AchDefaultPaymentType.All);
    const payrollFundingSources = fundingSources.filter(achMethod => achMethod.achDefaultPaymentType == AchDefaultPaymentType.Payroll);
    this.setDefaultFundingSourceForOrg(vendorFundingSources, payrollFundingSources, allFundingSources, paymentTxnType);
  }

  private setCheckPaymentMethodForOrg(fundingSources: OrgAchDetail[], paymentTxnType?: PaymentTxnType): void {
    const vendorFundingSources = fundingSources.filter(achMethod => achMethod.achDefaultPaymentType == AchDefaultPaymentType.VendorPayable);
    const allFundingSources = fundingSources.filter(achMethod => achMethod.achDefaultPaymentType == AchDefaultPaymentType.All);
    const payrollFundingSources = fundingSources.filter(achMethod => achMethod.achDefaultPaymentType == AchDefaultPaymentType.Payroll);
    this.setDefaultFundingSourceForOrg(vendorFundingSources, payrollFundingSources, allFundingSources, paymentTxnType);
  }

  private setDefaultFundingSourceForOrg(vendorFundingSources: AchFundingSource[] | OrgAchDetail[], payrollFundingSources: AchFundingSource[] | OrgAchDetail[], allFundingSources: AchFundingSource[] | OrgAchDetail[], paymentTxnType: PaymentTxnType): void {
    this.selectedFundingSource = null;
    if (paymentTxnType == PaymentTxnType.VoucherRegister) {
      if (vendorFundingSources && vendorFundingSources.length > 0) {
        //Set any of the funding sources as default selection
        this.selectedFundingSource = classToClass(vendorFundingSources[0]);
      } else if (allFundingSources && allFundingSources.length > 0) {
        //Set any of the funding sources as default selection
        this.selectedFundingSource = classToClass(allFundingSources[0]);
      }
      this.selectedFundingSourceEvent.emit(this.selectedFundingSource);

    } else if (paymentTxnType == PaymentTxnType.Payroll) {
      if (payrollFundingSources && payrollFundingSources.length > 0) {
        this.selectedFundingSource = classToClass(payrollFundingSources[0]);
      } else if (allFundingSources && allFundingSources.length > 0) {
        this.selectedFundingSource = classToClass(allFundingSources[0]);
      }
      this.selectedFundingSourceEvent.emit(this.selectedFundingSource);
    }
  }

}
